import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsNumber, IsOptional, IsString, ValidateNested, IsDateString } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class Task {
  @IsNumber()
  @Expose()
  id!: number;
  @IsNumber()
  @Expose()
  recordStampId!: number;
  @IsNumber()
  @Expose()
  type!: number;
  @IsString()
  @Expose()
  typeName!: string;
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @Expose()
  params!: string;
  @IsString()
  @Expose()
  officeShortName!: string;
  @IsDateString()
  @Expose()
  @IsOptional()
  nextRunAt!: string;
  @IsDateString()
  @Expose()
  @IsOptional()
  lastRunAt!: string;
  @IsBoolean()
  @Expose()
  inExecute!: boolean;
  @IsBoolean()
  @Expose()
  processed!: boolean;
  @IsBoolean()
  @Expose()
  enabled!: boolean;
  @IsBoolean()
  @Expose()
  isNextExecutionTimeConstant!: boolean;
  @IsBoolean()
  @Expose()
  isExecuteInTask!: boolean;
  @IsNumber()
  @Expose()
  unsuccessfulTryStartCounter!: number;
  @IsArray()
  @Expose()
  users!: Array<string>;
}

export class TaskResponse extends GenericTableResponse<Task> {
  @Expose()
  @IsArray()
  @Type(() => Task)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<Task>;
}
